import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Link } from 'react-router-dom';
import styles from './CTASection.module.css';
import { useLang } from '../context/LanguageContext';

const CTASection = () => {
  const ref = useRef(null);
  const inV = useInView(ref, { once: true, margin: '-80px' });
  const { t } = useLang();
  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.topLine} />
      <div className={styles.container}>
        <motion.div className={styles.inner}
          initial={{ opacity: 0, y: 28 }} animate={inV ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}>
          <span className={styles.tag}>{t.cta.tag}</span>
          <h2 className={styles.title}>{t.cta.title1}<br />{t.cta.title2}</h2>
          <p className={styles.sub}>{t.cta.sub}</p>
          <div className={styles.ctas}>
            <Link to="/contact" className={styles.primary}>
              {t.cta.primary}
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </Link>
            <Link to="/services" className={styles.ghost}>{t.cta.ghost}</Link>
          </div>
          <div className={styles.chips}>
            {t.cta.chips.map(c => <span key={c} className={styles.chip}>{c}</span>)}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
